import React, { useContext } from 'react';

import { LocaleContext } from '@repo/contexts/LocaleContext';
import LinkComponent from '@repo/ui-components/LinkComponent';
import ClipboardIcon from '@repo/ui-components/svgs/bs-clipboard-check.svg';
import BatteryIcon from '@repo/ui-components/svgs/bs-battery-full.svg';
import { LocaleCurrencyEnum } from '@repo/models/LocaleCurrencyEnum';

function LinkButtons() {
  const { currency } = useContext(LocaleContext);

  return (
    <div className="w-full flex flex-wrap flex-row gap-6">
      <LinkComponent
        to={
          currency === LocaleCurrencyEnum.CAD
            ? '/en-ca/free-consultation'
            : '/free-consultation'
        }
        className="flex w-full p-4 border border-brand text-brand-primary gap-4 md:[width:calc(50%-1rem)]"
      >
        <ClipboardIcon className="self-center" />
        <div>
          <p className="font-extrabold m-0">Not Yet a Customer?</p>
          <span className="inline-block no-underline">
            Schedule a Consultation
          </span>
        </div>
      </LinkComponent>
      <LinkComponent
        to={
          currency === LocaleCurrencyEnum.CAD
            ? '/en-ca/shop/batteries'
            : '/shop/batteries'
        }
        className="flex w-full p-4 border border-brand text-brand-primary gap-4 md:[width:calc(50%-1rem)]"
      >
        <BatteryIcon className="self-center" />
        <div>
          <p className="font-extrabold m-0">Existing Customer?</p>
          <span className="inline-block no-underline">Shop Batteries</span>
        </div>
      </LinkComponent>
    </div>
  );
}

export default LinkButtons;
